// extracted by mini-css-extract-plugin
export default {"commentBody":"PendingCommentPreview-module__commentBody___5gAWen"};